export enum RiskOrReturnEnum {
  RISK = 'risk',
  RETURN = 'return'
}
